import Axios from 'axios'
const cancelToken=Axios.CancelToken

const request={
  state:{
    source:cancelToken.source()
  },
  mutations:{
    SET_SOURCE:(state,value)=>{
      state.source=value

    }
  },

}
export default request
